import React, { Fragment, useState, useEffect } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import { useSelector, useDispatch } from "react-redux";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import Time from "react-time-format";
import { Button, Tooltip, Input } from "antd";
import { change_Lang } from "../../actions/Helper_action";
import { Search } from "react-feather";
import NumberFormat from "react-number-format";
import Swal from "sweetalert2";
import {
  Get_List_Tanents,
  Rent_Delete_Status,
  Tenant_View_Contracts,
  Tenant_View_takeMoney,
} from "../../actions/Invoice_action";
import { isMobile } from "react-device-detect";
import _ from "lodash";
const ReTenantList = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(Get_List_Tanents());
  }, []);
  const lang = useSelector((state) => state.HelperReducer.lang);
  const tanents_list = useSelector(
    (state) => state.InvoiceReducer.tanents_list
  );
  const tenant_status = useSelector(
    (state) => state.InvoiceReducer.tenant_status
  );
  const [search, setsearch] = useState("");
  const onDeleteTenant_Contract = (id, status) => {
    return Swal.fire({
      title: dispatch(change_Lang("Are you sure")),
      html: `<label class="fk">${dispatch(
        change_Lang("You won't be able to delete this!")
      )}</label>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: dispatch(change_Lang("Yes, delete it")),
      cancelButtonText: dispatch(change_Lang("cancel")),
      confirmButtonClass: "fk",
      cancelButtonClass: "fk",
      customClass: {
        title: "fk",
        content: "fk",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(Rent_Delete_Status(id, status));
        setTimeout(() => {
          dispatch(Get_List_Tanents());
        }, 1500);
        Swal.fire({
          title: dispatch(change_Lang("Delete")),
          text: dispatch(
            change_Lang("Your work has been successfully completed")
          ),
          timer: 1000,
          icon: "success",
          customClass: {
            title: "fk",
            content: "fk",
          },
        });
      }
    });
  };
  const Tenant_getPrint = () => {
    window.setTimeout("window.print()", 4000);
  };
  const datas = tanents_list
    .filter((data) => {
      if (data.tenantId && data.tenantId.isBalance !== "off") {
        if (search !== "") {
          if (isNaN(search)) {
            if (data.block && data.block.toString().startsWith(search)) {
              return data.block.toString().startsWith(search);
            } else if (
              data.tenantId &&
              data.tenantId.secondname
                .toLowerCase()
                .startsWith(search.toLowerCase())
            ) {
              return (
                data.tenantId &&
                data.tenantId.secondname
                  .toLowerCase()
                  .startsWith(search.toLowerCase())
              );
            } else if (
              data.available_id &&
              data.available_id.NOoFProperty.toString().startsWith(search)
            ) {
              return (
                data.available_id &&
                data.available_id.NOoFProperty.toString().startsWith(search)
              );
            } else if (
              data.available_id &&
              data.available_id.Place_ku.toLowerCase().startsWith(
                search.toLowerCase()
              )
            ) {
              return data.available_id &&
                data.available_id.Place_ku &&
                lang === "krd"
                ? data.available_id &&
                    data.available_id.Place_ku.toLowerCase().startsWith(
                      search.toLowerCase()
                    )
                : lang === "en"
                ? data.available_id &&
                  data.available_id.Place_en.toLowerCase().startsWith(
                    search.toLowerCase()
                  )
                : data.available_id &&
                  data.available_id.Place_ar.toLowerCase().startsWith(
                    search.toLowerCase()
                  );
            } else {
              return (
                dispatch(change_Lang(data.available_id.Property)) &&
                dispatch(change_Lang(data.available_id.Property))
                  .toLowerCase()
                  .startsWith(search.toLowerCase())
              );
            }
          } else if (
            data.available_id &&
            data.available_id.NOoFProperty.toString().startsWith(search)
          ) {
            return (
              data.available_id &&
              data.available_id.NOoFProperty.toString().startsWith(search)
            );
          } else {
            return (
              data.tenantId &&
              data.tenantId.phone2.toString().startsWith(search)
            );
          }
        } else {
          return data;
        }
      }
    })
    .map((el, i) => {
      return {
        id: tanents_list.length - i,

        secondname: (
          <label
            className={`${lang === "en" ? "" : "fk text-center"}`}
            style={{ cursor: "pointer" }}
          >
            {`${el.tenantId && el.tenantId.secondname}`}
            <br />
            {el.tenantId && el.tenantId.phone2}
          </label>
        ),
        repit: (
          <span className={`${lang === "en" ? "" : "fk text-center"}`}>
            {el.MonthForRent}&nbsp;{dispatch(change_Lang("month"))}
          </span>
        ),
        property_detail: (
          <>
            <span className={`${lang === "en" ? "" : "fk"}`}>
              {el.available_id &&
                dispatch(change_Lang(el.available_id.Property))}
            </span>
            &nbsp;-&nbsp;
            <span className={`${lang === "en" ? "" : "fk"}`}>
              {el.available_id && el.available_id.Property !== "Apartment"
                ? el.available_id && el.available_id.NOoFProperty
                : `${el.available_id && el.available_id.block}-${
                    el.available_id && el.available_id.flour
                  }-${el.available_id && el.available_id.NOoFProperty}`}
            </span>
          </>
        ),
        nextPayment: (
          <>
            <label className="text-center">
              <Time
                value={el.nextPayment}
                format="YYYY-MM-DD"
                style={{
                  fontSize: "16px",
                  color:
                    el.daysUntilNextPayment >= 5
                      ? "green"
                      : el.daysUntilNextPayment < 5 &&
                        el.daysUntilNextPayment >= 1
                      ? "orange"
                      : "red",
                }}
                className={`${lang === "en" ? "" : "fk"}`}
              />
              <br />
              <span
                style={{
                  fontSize: "16px",
                  color:
                    el.daysUntilNextPayment >= 5
                      ? "green"
                      : el.daysUntilNextPayment < 5 &&
                        el.daysUntilNextPayment >= 1
                      ? "orange"
                      : "red",
                }}
              >
                {el.daysUntilNextPayment}&nbsp;{dispatch(change_Lang("Day"))}
              </span>
            </label>
          </>
        ),
        date: (
          <Time
            value={el.createdAt}
            format="YYYY-MM-DD"
            style={{ color: "black" }}
            className={`${lang === "en" ? "" : "fk"}`}
          />
        ),
        balance: (
          <NumberFormat
            displayType="text"
            thousandSeparator={true}
            value={el.tenantId && el.tenantId.balance}
            className={`${lang === "en" ? "" : "fk"}`}
            prefix={`${
              el.available_id && el.available_id.currency !== "dolar"
                ? "IQD"
                : "$"
            }`}
          />
        ),
        saflyBalance: (
          <NumberFormat
            displayType="text"
            thousandSeparator={true}
            value={el.tenantId && el.tenantId.saflyBalance}
            className={`${lang === "en" ? "" : "fk"}`}
            prefix={`${
              el.available_id && el.available_id.currency !== "dolar"
                ? "IQD"
                : "$"
            }`}
          />
        ),
        month_salary: (
          <NumberFormat
            displayType="text"
            thousandSeparator={true}
            value={el.paymentmonth}
            className={`${lang === "en" ? "" : "fk"}`}
            prefix={`${
              el.available_id && el.available_id.currency !== "dolar"
                ? "IQD"
                : "$"
            }`}
          />
        ),
        action: (
          <>
            <Tooltip
              className="fk"
              title={
                <span style={{ fontSize: "12px" }} className="fk">
                  {dispatch(change_Lang("Repayment bills"))}
                </span>
              }
            >
              <Link
                to={`/Tenant_View_All_TakeMoney/${
                  el.tenantId && el.tenantId._id
                }`}
              >
                <Button
                  style={{ background: "#efefed", color: "#295a68" }}
                  shape="circle"
                  onClick={() => {
                    dispatch(
                      Tenant_View_takeMoney(el.tenantId && el.tenantId._id)
                    );
                  }}
                  icon={
                    <i
                      style={{
                        cursor: "pointer",
                      }}
                      className="fas fa-file-alt text-center mt-1"
                    ></i>
                  }
                />
              </Link>
            </Tooltip>
            &nbsp;
            <Tooltip
              className="fk"
              title={
                <span style={{ fontSize: "12px" }} className="fk">
                  {dispatch(change_Lang("Payment bills"))}
                </span>
              }
            >
              <Link
                to={`/Tenant_View_All_Paradan/${
                  el.tenantId && el.tenantId._id
                }`}
              >
                <Button
                  style={{ background: "#efefed", color: "#295a68" }}
                  shape="circle"
                  onClick={() => {
                    dispatch(
                      Tenant_View_takeMoney(el.tenantId && el.tenantId._id)
                    );
                  }}
                  icon={
                    <i
                      style={{
                        cursor: "pointer",
                      }}
                      className="far fa-file-alt text-center mt-1"
                    ></i>
                  }
                />
              </Link>
            </Tooltip>
            &nbsp;
            <Tooltip
              className="fk"
              title={
                <span style={{ fontSize: "12px" }} className="fk">
                  {dispatch(change_Lang("View Recontract"))}
                </span>
              }
            >
              <Link
                to={`/Tenant_View_All_Contract/${
                  el.tenantId && el.tenantId._id
                }`}
              >
                <Button
                  style={{ background: "#efefed", color: "#295a68" }}
                  shape="circle"
                  onClick={() => {
                    dispatch(
                      Tenant_View_Contracts(el.tenantId && el.tenantId._id)
                    );
                  }}
                  icon={
                    <i
                      style={{
                        cursor: "pointer",
                      }}
                      className="fas fa-file-invoice text-center mt-1"
                    ></i>
                  }
                />
              </Link>
            </Tooltip>
            &nbsp;
            <Tooltip
              title={
                <span style={{ fontSize: "12px" }} className="fk">
                  {dispatch(change_Lang("Add_delete"))}
                </span>
              }
            >
              <Button
                style={{ background: "#efefed", color: "#295a68" }}
                shape="circle"
                icon={
                  <i
                    onClick={() => onDeleteTenant_Contract(el._id, "delete")}
                    style={{
                      cursor: "pointer",
                    }}
                    className="fas fa-ban text-center mt-1"
                  ></i>
                }
              />
            </Tooltip>
          </>
        ),
      };
    });
  const columns = [
    {
      name: dispatch(change_Lang("d_productname")),
      selector: "secondname",
      center: true,
      compact: true,
      width: "180px",
    },
    {
      name: dispatch(change_Lang("Property Detail")),
      selector: "property_detail",
      center: true,
      compact: true,
      width: "150px",
    },
    {
      name: dispatch(change_Lang("monthly payments")),
      selector: "month_salary",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("Recurrence")),
      selector: "repit",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("Contract Date")),
      selector: "date",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("next Repayment")),
      selector: "nextPayment",
      center: true,
      compact: true,
      width: "130px",
    },
    {
      name: dispatch(change_Lang("Balance of Assurance")),
      selector: "saflyBalance",
      center: true,
      compact: true,
      width: "110px",
    },
    {
      name: dispatch(change_Lang("Balance")),
      selector: "balance",
      center: true,
      compact: true,
      width: "90px",
    },
    {
      name: dispatch(change_Lang("Action")),
      selector: "action",
      center: true,
      compact: true,
      width: "180px",
    },
  ];
  const customStyles = {
    header: {
      style: {
        minHeight: "0.1px",
        background: "#e3e9f2",
      },
    },
    headRow: {
      style: {
        background: "#e3e9f2",
      },
    },
    headCells: {
      style: {
        color: "black",
        fontSize: "14px",
      },
    },
  };
  const Total_Balance_Dolar = _.sumBy(tanents_list, function (o) {
    if (o.available_id && o.available_id.currency === "dolar") {
      return Number(o.tenantId && o.tenantId.balance);
    } else {
      return 0;
    }
  });
  const Total_Balance_Dinar = _.sumBy(tanents_list, function (o) {
    if (o.available_id && o.available_id.currency !== "dolar") {
      return Number(o.tenantId && o.tenantId.balance);
    } else {
      return 0;
    }
  });
  const Total_Assurance_Balance_Dolar = _.sumBy(tanents_list, function (o) {
    if (o.available_id && o.available_id.currency === "dolar") {
      return Number(o.tenantId && o.tenantId.saflyBalance);
    } else {
      return 0;
    }
  });
  const Total_Assurance_Balance_Dinar = _.sumBy(tanents_list, function (o) {
    if (o.available_id && o.available_id.currency !== "dolar") {
      return Number(o.tenantId && o.tenantId.saflyBalance);
    } else {
      return 0;
    }
  });
  return (
    <Fragment>
      <Breadcrumb
        title={dispatch(change_Lang("List of Tenants"))}
        parent={dispatch(change_Lang("Tenants_"))}
      />
      {tenant_status !== true ? (
        <div className="loader-container">
          <div className="spinner"></div>
        </div>
      ) : (
        <>
          <div
            className={`${
              lang === "en" ? "container-fluid" : "container-fluid fk"
            }`}
          >
            <div className="row">
              <div className="col-xs-12 col-sm-12 ">
                <div>
                  <div className="row ">
                    <div
                      className={
                        isMobile
                          ? "col-md-3 d-flex justify-content-center"
                          : "col-md-3 d-flex justify-content-start"
                      }
                    >
                      <Link to="/Print_all_tenants">
                        <Button
                          type="button"
                          className="mr-2"
                          onClick={Tenant_getPrint}
                          style={{
                            background: "#295a68",
                            color: "#efefed",
                            fontSize: "14px",
                          }}
                          size="middle"
                          shape="default"
                          icon={
                            <i
                              className="fa fa-print"
                              aria-hidden="true"
                              style={{ fontSize: "10px" }}
                            ></i>
                          }
                        >
                          &nbsp;{dispatch(change_Lang("Print"))}
                        </Button>
                      </Link>
                    </div>
                    <div className={"col-md-6"}>
                      <div className=" text-center">
                        <h3 style={{ fontWeight: "bold", color: "#295a68" }}>
                          {dispatch(change_Lang("List of Tenants"))}
                        </h3>
                      </div>
                    </div>
                    <div className="col-md-3 m-auto">
                      <div className="form-group form-inline d-flex justify-content-end">
                        <Input
                          type="text"
                          name="search"
                          value={search}
                          onChange={(e) => setsearch(e.target.value)}
                          size="middle"
                          placeholder={dispatch(change_Lang("Search"))}
                          autoComplete="off"
                          style={{ width: "180px" }}
                          prefix={<Search color="lightgray" />}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="user-status table-responsive latest-order-table">
                    <DataTable
                      columns={columns}
                      className={`${lang === "en" ? "" : "fk"}`}
                      customStyles={customStyles}
                      data={datas}
                      pagination={true}
                      striped
                    />
                  </div>
                  <br />
                  <div class="container">
                    <ul class="responsive-table">
                      <li class="table-header">
                        <div class="col d-flex justify-content-center">
                          کۆی باڵانس بە $
                        </div>
                        <div class="col d-flex justify-content-center">
                          کۆی باڵانس بە IQD
                        </div>
                        <div class="col d-flex justify-content-center">
                          کۆی باڵانسی دڵنیایی بە $
                        </div>
                        <div class="col d-flex justify-content-center">
                          کۆی باڵانسی دڵنیایی بە IQD
                        </div>
                      </li>
                      <td></td>
                      <li class="table-row">
                        <div
                          class="col d-flex justify-content-center"
                          data-label="Payment Status"
                        >
                          <NumberFormat
                            displayType="text"
                            thousandSeparator={true}
                            value={Total_Balance_Dolar}
                            className={`${lang === "en" ? "" : "fk"}`}
                            prefix="$"
                          />
                        </div>
                        <div
                          class="col d-flex justify-content-center"
                          data-label="Payment Status"
                        >
                          <NumberFormat
                            displayType="text"
                            thousandSeparator={true}
                            value={Total_Balance_Dinar}
                            className={`${lang === "en" ? "" : "fk"}`}
                            prefix="IQD "
                          />
                        </div>
                        <div
                          class="col d-flex justify-content-center"
                          data-label="Payment Status"
                        >
                          <NumberFormat
                            displayType="text"
                            thousandSeparator={true}
                            value={Total_Assurance_Balance_Dolar}
                            className={`${lang === "en" ? "" : "fk"}`}
                            prefix="$"
                          />
                        </div>
                        <div
                          class="col d-flex justify-content-center"
                          data-label="Customer Name"
                        >
                          <NumberFormat
                            displayType="text"
                            thousandSeparator={true}
                            value={Total_Assurance_Balance_Dinar}
                            className={`${lang === "en" ? "" : "fk"}`}
                            prefix="IQD"
                            style={{ color: "black" }}
                          />
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </Fragment>
  );
};

export default ReTenantList;
